export default __webpack_public_path__ + "static/media/downVector.f6fbee10.svg";